module.exports = __webpack_public_path__ + "img/icon-round-youtube.d5e88ab8.svg";